// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AppleController from "./apple_controller"
application.register("apple", AppleController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MicroController from "./micro_controller"
application.register("micro", MicroController)

import NotificationsController from "./notifications_controller"
application.register("notifications", NotificationsController)

import PaymentsController from "./payments_controller"
application.register("payments", PaymentsController)

import PlayerController from "./player_controller"
application.register("player", PlayerController)

import PopupController from "./popup_controller"
application.register("popup", PopupController)

import ReaderController from "./reader_controller"
application.register("reader", ReaderController)

import RecordController from "./record_controller"
application.register("record", RecordController)
